import * as Sentry from '@sentry/nextjs';
import type { AppProps } from 'next/app';
import 'styles/globals.css';
import 'styles/variables/_colors.css';
import '@uchi/dino-modal/build/main.css'; // проверить влияние на загрузку
import '@uchi/dino-input/build/main.css';
import '@uchi/tokens-0-4/css/tokens.css';
import '@uchi/dino-button/build/main.css';
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { NextPage, NextPageContext } from 'next';
import { ESI } from '@uchi/esi-component';
import AuthController from 'views/AuthController/AuthController';
import { UserData } from 'context/AuthContext/AuthContext.types';
import { logInfo } from 'utils/logging';
import checkAuthFromHeaders from 'utils/checkAuthFromHeaders';
import getUser from '../api/requests/getUser';

// eslint-disable-next-line
export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
  data: UserData | null;
};

function App({ Component, pageProps, data }: AppPropsWithLayout) {
  const getLayout = Component.getLayout ?? ((page) => page);

  useEffect(() => {
    const component = new ESI(document);
    component.init();
  }, []);

  return (
    <>
      <AuthController userData={data}>
        {getLayout(<Component {...pageProps} />)}
      </AuthController>
    </>
  );
}

App.getInitialProps = async ({ ctx }: { ctx: NextPageContext }) => {
  const userAuth = checkAuthFromHeaders(ctx);
  if (userAuth) {
    const userData = await getUser(ctx);

    if (userData?.avatar && userData?.data.attributes?.foreign_id) {
      Sentry.setUser({ id: userData.data.attributes.foreign_id.toString() });
    }

    return {
      data: {
        ...userData,
      },
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    logInfo(`user without cookie`);
  }

  return {
    data: null,
  };
};

export default App;
